import React from 'react'

import { Field } from 'common/fields/entities/field'
import MCEditorContext from 'components/MCTextEditor/MCEditorContext'
import { IVariableData } from 'components/MCTextEditor/types'

import cm from './Variable.module.css'

const VariablePreview = ({
  data,
  children,
}: {
  data: IVariableData
  children?: React.ReactNode
}) => {
  const { variables } = React.useContext(MCEditorContext)
  const isReplaced = variables.getPreviewValue?.(data) === children
  const tooltip = getTooltip(
    variables.getFields().find((field) => field.id === data.id),
    isReplaced,
  )

  return (
    <span className={cm.preview} data-title={tooltip}>
      {children}
    </span>
  )
}

export default VariablePreview

const getTooltip = (field: Field | undefined, isReplaced: boolean) => {
  const caption = field?.caption ?? ''
  if (isReplaced) {
    return `We've replaced the '${caption}' variable with info from your profile, so you could see how it looks for your contacts.`
  }
  return `This text will be replaced with '${caption}' field value if it's available, otherwise with fallback (empty by default)`
}
